<template>
	<v-tooltip location="top" :open-on-focus="true">
		<template #activator="{ props: tooltipProps }">
			<v-btn
				v-bind="tooltipProps"
				class="partial-recording-indicator"
				variant="flat"
				color="warning"
				size="24"
				icon
				aria-label="Partial recording. Open recording for upload instructions."
				data-test-id="partial-recording-indicator"
				@click.stop="emit('open')">
				<v-icon size="18">mdi-alert-circle-outline</v-icon>
			</v-btn>
		</template>
		Partial recording. This recording didn’t finish uploading. Open it for instructions to upload the rest from the original device.
	</v-tooltip>
</template>

<script setup lang="ts">
	const emit = defineEmits<{ open: [] }>();
</script>
